class ConsultaFallecido {
    public cedulaBeneficiario: string;
    public cedulaFallecido: string;
    public captchaToken: string = "";
}

class ConsultaFallecidoResp {
    public primerNombre: string;
    public segundoNombre: string;
    public primerApellido: string;
    public segundoApellido: string;
    public aplicaTramite: boolean;
    public requiereDocumento: boolean;
    public tipoAccionAplica: string;
    public estado: string;
    public mensaje: string;
}

class ConsultaValidacionBeneficiarioResp {
    constructor(
        public primerNombre: string = null,
        public segundoNombre: string = null,
        public primerApellido: string = null,
        public segundoApellido: string = null,
        public email1: string = null,
        public email2: string = null,
        public celular: string = null,
        public esAfiliado: boolean = null,
        public estaRegistrado: boolean = null
    ) {}
}

class ConsultaValidacionFallecimientoAll {
    public validacionFallecido:ConsultaFallecidoResp;
    public validacionBeneficiario:ConsultaValidacionBeneficiarioResp;
}

export default ConsultaFallecido
export { ConsultaFallecidoResp, ConsultaValidacionBeneficiarioResp, ConsultaValidacionFallecimientoAll }